export default __webpack_public_path__ + "static/media/medisail.507b1688.png";